<template>
    <div style="overflow-y: auto" class="container">
        <!-- 高德地图 -->
        <div style="display: flex">
            <el-button @click="add_isShow = !add_isShow" style="margin-right: 20px" type="primary">城市详情</el-button>

            <!-- 热力图查询条件 -->
            <div>
                <span>时间: </span>

                <el-date-picker
                    v-model="search_time"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    @change="timeChange"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>
            <div style="margin-left: 30px">
                <el-radio-group v-model="search_data.type" size="small" @change="getReLi">
                    <el-radio label="1" border>下单热力值</el-radio>
                    <el-radio label="2" border>销单热力值</el-radio>
                </el-radio-group>
            </div>
        </div>

        <!-- 高德地图功能组件 -->
        <div id="container_details">
            <div style="background-color: rgba(255, 255, 255, 0.1); border-radius: 0px; position: absolute; padding: 10px 15px; bottom: 50px; left: 20px;"><h5 style="color: rgb(0, 0, 0); font-size: 16px; font-weight: bold; padding: 0px 0px 5px; margin: 0px;">订单数量</h5><ul style="margin: 0px; padding: 0px; list-style: none;">
                <li style="height: 16px; box-sizing: content-box; padding: 2px 0;"><span style="background-color: #F4FFB3; float:left; width: 16px; height: 16px;"></span><a style="float:left; height: 16px; line-height: 16px; text-align: left; padding-left: 10px; font-size: 12px; color: rgba(0,0,0,1);">&gt; 7</a></li>

                <li style="height: 16px; box-sizing: content-box; padding: 2px 0;"><span style="background-color: #BFDDA8; float:left; width: 16px; height: 16px;"></span><a style="float:left; height: 16px; line-height: 16px; text-align: left; padding-left: 10px; font-size: 12px; color: rgba(0,0,0,1);">&lt; 7</a></li>

                <li style="height: 16px; box-sizing: content-box; padding: 2px 0;"><span style="background-color: #96CA8D; float:left; width: 16px; height: 16px;"></span><a style="float:left; height: 16px; line-height: 16px; text-align: left; padding-left: 10px; font-size: 12px; color: rgba(0,0,0,1);">&lt; 6</a></li>

                <li style="height: 16px; box-sizing: content-box; padding: 2px 0;"><span style="background-color: #75BA89; float:left; width: 16px; height: 16px;"></span><a style="float:left; height: 16px; line-height: 16px; text-align: left; padding-left: 10px; font-size: 12px; color: rgba(0,0,0,1);">&lt; 5</a></li>

                <li style="height: 16px; box-sizing: content-box; padding: 2px 0;"><span style="background-color: #5EAC86; float:left; width: 16px; height: 16px;"></span><a style="float:left; height: 16px; line-height: 16px; text-align: left; padding-left: 10px; font-size: 12px; color: rgba(0,0,0,1);">&lt; 4</a></li>

                <li style="height: 16px; box-sizing: content-box; padding: 2px 0;"><span style="background-color: #4D9A96; float:left; width: 16px; height: 16px;"></span><a style="float:left; height: 16px; line-height: 16px; text-align: left; padding-left: 10px; font-size: 12px; color: rgba(0,0,0,1);">&lt; 3</a></li>

                <li style="height: 16px; box-sizing: content-box; padding: 2px 0;"><span style="background-color: #3F748F; float:left; width: 16px; height: 16px;"></span><a style="float:left; height: 16px; line-height: 16px; text-align: left; padding-left: 10px; font-size: 12px; color: rgba(0,0,0,1);">&lt; 2</a></li>

                <li style="height: 16px; box-sizing: content-box; padding: 2px 0;"><span style="background-color: #1D3748; float:left; width: 16px; height: 16px;"></span><a style="float:left; height: 16px; line-height: 16px; text-align: left; padding-left: 10px; font-size: 12px; color: rgba(0,0,0,1);">&lt; 1</a></li>
            </ul></div>
        </div>
        <div class="legend">
            <ul class="colors" id="legend-color"></ul>
            <ul class="labels" id="legend-label"></ul>
        </div>
        <!-- 热力图点击显示数据 -->
        <div id="hot-style" style="display: none">
            <div>当前坐标{{ titleText }}量：{{ countHot }}</div>
            <div>经度：{{ arrlng }}</div>
            <div>纬度：{{ arrlat }}</div>
        </div>
        <!-- <div class="info" style="min-width: 350px; mex-width: 450px">
            <h4>热力事件回调参数</h4>
            <p>当前热力值：<span id="val">--</span></p>
            <p>当前包含的数据索引：<span id="indexes" style="display: block; overflow: scroll">--</span></p>
            <p>当前包含的数据数量：<span id="indexes-num">--</span></p>
            <p>
                热力中心点坐标：
                <span id="lng-lat">--</span>
            </p>
        </div> -->

        <!-- <div class="input-card" style="width: auto">
            <div class="input-item">
                <button class="btn" @click="heatmap.show()">显示热力图</button>
            </div>
            <div class="input-item"><button class="btn" @click="heatmap.hide()">关闭热力图</button></div>
        </div> -->

        <!-- 编辑组件 -->
        <detailsCity :isShow="add_isShow" :data="data_lists"></detailsCity>
    </div>
</template>


<script>
// import 'https://webapi.amap.com/loca?v=2.0.0&key=10bf9af114949bea4c5df7207fc35a13'
// import 'https://a.amap.com/Loca/static/mock/bj_heat_grid.js'
// import 'https://a.amap.com/Loca/static/manual/example/script/demo.js'

var _this, district, map, layer, hexagon;
import detailsCity from './detailsCity.vue';

export default {
    components: {
        detailsCity
    },
    data() {
        return {
            titleText: '下单',
            countHot: 0,
            arrlat: '',
            arrlng: '',
            add_isShow: false,

            arr: [
                // pos 为位置坐标。
                // cnt 为该点的数据，数据要求为 number 类型。
                { pos: [112.1, 39.9], cnt: 10 },
                { pos: [136.3, 23.1], cnt: 20 }
                // ...
            ],
            heatmapData: [],

            search_time: [],
            search_data: {
                type: '1',
                start_stamp: '',
                end_stamp: ''
            },

            data_lists: {}
        };
    },
    created() {
        _this = this;
        _this.getDate();
    },
    async mounted() {
        await _this.getMap();
    },
    methods: {
        getDate() {
            // console.log('获取默认查询日期');
            const today = new Date();
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1); // 昨天

            const twoDaysAgo = new Date(today); // 前天
            twoDaysAgo.setDate(twoDaysAgo.getDate() - 2); // 前天

            _this.search_data.start_stamp = _this.formatDate(yesterday);
            _this.search_data.end_stamp = _this.formatDate(today);
            _this.search_time[0] = _this.formatDate(yesterday);
            _this.search_time[1] = _this.formatDate(today);
            // console.log(_this.search_time, '_this.search_time');

            _this.getReLi();
        },
        // 把时间戳转化成年月日
        formatDate(date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');

            return `${year}-${month}-${day}`;
        },
        // 加载地图画围栏
        async getMap() {
            // 地图初始化
            map = new TMap.Map('container_details', {
                zoom: 11.43,
                center: [30.199146446037616, 120.2446746826172],
                pitch: 55,
                rotation: 20,
                // showLabel: true,
                viewMode: '3D'
            });

            // 获取城市详情
            _this
                .$post('/admin.php/city/getCityDetails')
                .then((res) => {
                    _this.data_lists = res.data;
                    // 判断是否存在绿色围栏数据
                    if (
                        _this.data_lists.free_area_coordinate_array != null &&
                        _this.data_lists.free_area_coordinate_array &&
                        _this.data_lists.free_area_coordinate_array != '' &&
                        _this.data_lists.free_area_coordinate_array != '[]'
                    ) {
                        let coordinateArray = JSON.parse(_this.data_lists.free_area_coordinate_array);

                        coordinateArray.push(JSON.parse(_this.data_lists.free_area_coordinate_array)[0]);
                        var free_area_coordinateArray = coordinateArray.map(coord => new TMap.LatLng(coord[1], coord[0]))

                        // 一小时围栏的初始化设置
                        var free_area_polygon = new TMap.MultiPolyline({
                            map: map,
                            //折线样式定义
                            styles: {
                                'style_green': new TMap.PolylineStyle({
                                    'color': '#008000', //线填充色
                                    'width': 6, //折线宽度
                                    'lineCap': 'round' //线端头方式
                                }),
                            },
                            //折线数据定义
                            geometries: [
                                {//第1条线
                                    'id': 'pl_1',//折线唯一标识，删除时使用
                                    'styleId': 'style_green',//绑定样式名
                                    'paths': free_area_coordinateArray
                                }
                            ],
                        });
                    }

                    // 判断是否存在粉色围栏数据
                    if (
                        _this.data_lists.far_area_coordinate_array != null &&
                        _this.data_lists.far_area_coordinate_array &&
                        _this.data_lists.far_area_coordinate_array != '' &&
                        _this.data_lists.far_area_coordinate_array != '[]'
                    ) {
                        let coordinateArray = JSON.parse(_this.data_lists.far_area_coordinate_array);
                        coordinateArray.push(JSON.parse(_this.data_lists.far_area_coordinate_array)[0]);
                        var far_area_coordinateArray = coordinateArray.map(coord => new TMap.LatLng(coord[1], coord[0]))
                        // 一小时围栏的初始化设置
                        var far_area_polygon = new TMap.MultiPolyline({
                            map: map,
                            //折线样式定义
                            styles: {
                                'style_pink': new TMap.PolylineStyle({
                                    'color': '#FF33FF', //线填充色
                                    'width': 6, //折线宽度
                                    'lineCap': 'round' //线端头方式
                                }),
                            },
                            //折线数据定义
                            geometries: [
                                {//第1条线
                                    'id': 'pl_2',//折线唯一标识，删除时使用
                                    'styleId': 'style_pink',//绑定样式名
                                    'paths': far_area_coordinateArray
                                }
                            ],
                        });
                    }

                    // 判断是否存在黑色围栏数据
                    if (
                        _this.data_lists.effective_area_coordinate_array != null &&
                        _this.data_lists.effective_area_coordinate_array &&
                        _this.data_lists.effective_area_coordinate_array != '' &&
                        _this.data_lists.effective_area_coordinate_array != '[]'
                    ) {
                        let coordinateArray = JSON.parse(_this.data_lists.effective_area_coordinate_array);
                        coordinateArray.push(JSON.parse(_this.data_lists.effective_area_coordinate_array)[0]);
                        var effective_area_coordinateArray = coordinateArray.map(coord => new TMap.LatLng(coord[1], coord[0]))
                        // 一小时围栏的初始化设置
                        var effective_area_polygon = new TMap.MultiPolyline({
                            map: map,
                            //折线样式定义
                            styles: {
                                'style_black': new TMap.PolylineStyle({
                                    'color': '#000000', //线填充色
                                    'width': 6, //折线宽度
                                    'lineCap': 'round' //线端头方式
                                }),
                            },
                            //折线数据定义
                            geometries: [
                                {//第1条线
                                    'id': 'pl_3',//折线唯一标识，删除时使用
                                    'styleId': 'style_black',//绑定样式名
                                    'paths': effective_area_coordinateArray
                                }
                            ],
                        });
                    }

                    // 缩放地图到合适的视野级别
                    // map.setFitView([free_area_polygon],true);
                    //设置地图中心和缩放级别
                    var center = res.data.center;
                    console.log(center);
                    const [lng, lat] = center.split(',').map(Number);
                    map.setCenter(new TMap.LatLng(lat, lng));
                    return true;
                })
                .catch((err) => {});
        },
        getReLi() {
            console.log(111111111111);
            _this.heatmapData = [];
            // console.log(_this.heatmapData, '获取热力图前清空数组，防止数组累加');
            if (_this.search_data.type == '1') {
                _this.titleText = '下单';
            } else {
                _this.titleText = '销单';
            }

            _this
                .$post('/city/getCityOrderHeatNew', _this.search_data)
                .then((res) => {
                    if(hexagon){
                        hexagon.remove();
                    }
                    let data = res.data.features;
                    data.forEach(d => {
                        let count = parseFloat(d.properties.rank);

                        if (count) {
                            let lat = parseFloat(d.geometry.coordinates[1]);
                            let lng = parseFloat(d.geometry.coordinates[0]);
                            _this.heatmapData.push({
                                lat,
                                lng,
                                count
                            });
                        }
                    });
                    console.log(_this.heatmapData);
                    //初始化蜂窝热力图图并添加至map图层
                    hexagon =new TMap.visualization.Hexagon({
                        radius: 100, //六边形中心点到端点的距离（半径）
                        extrudable: true,//六边形是否可拔起
                        heightRange: [1,1000], // 高度变化区间
                        showRange:[1, 100], //蜂窝聚合数据显示区间
                        toggleAnimation: {
                            animationType: "grow", //动画类型
                            duration: 3000, //动画时长
                        },
                        colorList:['#F4FFB3', '#BFDDA8', '#96CA8D', '#75BA89', '#5EAC86', '#4D9A96', '#3F748F', '#1D3748'].reverse()
                    })
                    .addTo(map)
                    .setData(_this.heatmapData);//设置数据
                    // 数据聚合之后才能够真正获取值域范围
                    hexagon.setShowRange(hexagon.getValueRange());

                    // AMap.plugin(['Loca.HexagonLayer'], () => {

                    //     if (layer) {
                    //         // map.remove(layer);
                    //         layer.clear();
                    //     }
                    //     layer = new Loca.Container({
                    //         map,
                    //     });



                    //     layer.ambLight = {
                    //         intensity: 0.4,
                    //         color: '#ced5ed',
                    //     };
                    //     layer.dirLight = {
                    //         intensity: 0.02,
                    //         color: '#666',
                    //         target: [10, 10, 10],
                    //         position: [0, -1, 0.1],
                    //     };
                    //     layer.pointLight = {
                    //         color: 'rgb(155,173,80)',
                    //         position: [120.14133, 30.246611, 20000],
                    //         intensity: 2.2,
                    //         // 距离表示从光源到光照强度为 0 的位置，0 就是光不会消失。
                    //         distance: 40000,
                    //     };

                    //     var geo = new Loca.GeoJSONSource({
                    //         data: _this.heatmapData,
                    //         // url: 'https://a.amap.com/Loca/static/loca-v2/demos/mock_data/hz_road_level.json',
                    //     });
                    //     // console.log(geo,2222)

                    //     var ll = new Loca.HexagonLayer({
                    //         // loca,
                    //         zIndex: 10,
                    //         opacity: 1,
                    //         visible: true,
                    //         zooms: [2, 22],
                    //         acceptLight: true,
                    //     });

                    //     var colors = ['#F4FFB3', '#BFDDA8', '#96CA8D', '#75BA89', '#5EAC86', '#4D9A96', '#3F748F', '#1D3748'].reverse();
                    //     var heights = [100, 200, 300, 900, 1000, 1200, 1500, 3000];
                    //     ll.setSource(geo);

                    //     // 计算路口rank之和
                    //     function sum(arr) {
                    //         // console.log(arr,'sum---------');
                    //         var sum = 0;
                    //         arr.forEach(a => {
                    //             console.log(a,3333);
                    //             sum += a.properties.rank;
                    //         });
                    //         return sum;
                    //     }

                    //     ll.setStyle({
                    //         unit: 'meter',
                    //         radius: 120,
                    //         gap: 0,
                    //         altitude: 0,
                    //         height: function (index, feature) {

                    //             // console.log(feature,'feature');
                    //             var ranks = sum(feature.coordinates);
                    //             // return ranks < 60 ? heights[2] : heights[6];
                    //             return ranks < 1 ?
                    //                 heights[0] : ranks < 2 ?
                    //                     heights[1] : ranks < 3 ?
                    //                         heights[2] : ranks < 4 ?
                    //                             heights[3] : ranks < 5 ?
                    //                                 heights[4] : ranks < 6 ?
                    //                                     heights[5] : ranks < 7 ?
                    //                                         heights[6] : heights[7];
                    //         },
                    //         topColor: function (index, feature) {
                    //             var ranks = sum(feature.coordinates);
                    //             // return ranks < 60 ? colors[1] : colors[6];
                    //             return ranks < 1 ?
                    //                 colors[0] : ranks < 2 ?
                    //                     colors[1] : ranks < 3 ?
                    //                         colors[2] : ranks < 4 ?
                    //                             colors[3] : ranks < 5 ?
                    //                                 colors[4] : ranks < 6 ?
                    //                                     colors[5] : ranks < 7 ?
                    //                                         colors[6] : colors[7];
                    //         },
                    //         sideBottomColor: function (index, feature) {
                    //             var ranks = sum(feature.coordinates);
                    //             // return ranks < 60 ? colors[1] : colors[6];
                    //             return ranks < 1 ?
                    //                 colors[0] : ranks < 2 ?
                    //                     colors[1] : ranks < 3 ?
                    //                         colors[2] : ranks < 4 ?
                    //                             colors[3] : ranks < 5 ?
                    //                                 colors[4] : ranks < 6 ?
                    //                                     colors[5] : ranks < 7 ?
                    //                                         colors[6] : colors[7];
                    //         },
                    //         sideTopColor: function (index, feature) {
                    //             var ranks = sum(feature.coordinates);
                    //             // return ranks < 60 ? colors[1] : colors[6];
                    //             return ranks < 1 ?
                    //                 colors[0] : ranks < 2 ?
                    //                     colors[1] : ranks < 3 ?
                    //                         colors[2] : ranks < 4 ?
                    //                             colors[3] : ranks < 5 ?
                    //                                 colors[4] : ranks < 6 ?
                    //                                     colors[5] : ranks < 7 ?
                    //                                         colors[6] : colors[7];
                    //         }
                    //     })
                    //     layer.add(ll);
                    //     // 高度升起动画
                    //     map.on('complete', function () {
                    //     setTimeout(function () {
                    //         ll.show(500);
                    //         ll.addAnimate({
                    //         key: 'height',
                    //         value: [0, 1],
                    //         duration: 500,
                    //         easing: 'Linear',
                    //         transform: 500,
                    //         random: true,
                    //         delay: 10000,
                    //         });
                    //     }, 800);
                    //     });
                    //     layer.animate.start();

                    //     // 图例
                    //     var lengend = new Loca.Legend({
                    //         loca: layer,
                    //         title: {
                    //             label: '订单数量',
                    //             fontColor: 'rgba(0,0,0,1)',
                    //             fontSize: '16px'
                    //         },
                    //         style: {
                    //             backgroundColor: 'rgba(255,255,255,0.1)',
                    //             fontColor: 'rgba(0,0,0,1)',
                    //             left: '20px',
                    //             bottom: '40px',
                    //             fontSize: '12px'
                    //         },
                    //         dataMap: [
                    //             { label: '> 7', color: colors[7] },
                    //             { label: '< 7', color: colors[6] },
                    //             { label: '< 6', color: colors[5] },
                    //             { label: '< 5', color: colors[4] },
                    //             { label: '< 4', color: colors[3] },
                    //             { label: '< 3', color: colors[2] },
                    //             { label: '< 2', color: colors[1] },
                    //             { label: '< 1', color: colors[0] },
                    //         ],
                    //     });







                        // layer = new Loca.HexagonLayer({
                        //     map: map,
                        //     fitView: true,
                        //     eventSupport: true
                        // });

                        // console.log(layer, '-0------------');
                        // if (_this.heatmapData.length != 0) {
                        //     layer.setData(_this.heatmapData, {
                        //         lnglat: function (obj) {
                        //             var val = obj.value;
                        //             return [val['lng'], val['lat']];
                        //         },
                        //         value: 'count'
                        //     });

                        //     layer.setOptions({
                        //         style: {
                        //             // 蜂窝热力半径，单位：米
                        //             radius: 100,
                        //             opacity: [0.5, 0.5],
                        //             // 热力聚合模式，count 为点数量加和
                        //             mode: 'sum', // 聚合模式，可选值: sum(值求和)、max(最大值)、min(最小值)、mean(平均值)、median(中位数)、count(个数)
                        //             // 颜色范围
                        //             color: [
                        //                 '#261cff',
                        //                 // '#7b00ff',
                        //                 '#00fffb',
                        //                 // '#06ff02',
                        //                 '#c5ff00',
                        //                 // '#fffb00',
                        //                 '#ff9300',
                        //                 // '#ff4a00',
                        //                 '#ff00fe',
                        //                 // '#ff0064',
                        //                 '#ff0700'
                        //             ],
                        //             height: [0, 11500],
                        //             // gap:500,
                        //             text: {
                        //                 content: function (data) {
                        //                     return data.value.sum;
                        //                 }, // 文字内容
                        //                 direction: 'center', // 文字方位
                        //                 // offset: [10, -10],  // 偏移大小
                        //                 fontSize: 16, // 文字大小
                        //                 fillColor: '#E67E22', //文字颜色
                        //                 strokeColor: 'rgba(255,255,255,0.85)', // 文字描边颜色
                        //                 strokeWidth: 1 // 文字描边宽度
                        //             }
                        //         }
                        //     });
                        //     // 事件 legendupdate: 图例数据更新完成回调此函数
                        //     layer.on('legendupdate', function (ev) {
                        //         var colorLegend = ev.colorLegend;
                        //         console.log(colorLegend, 'colorLegend===');
                        //         initLegend(colorLegend);
                        //     });

                        //     // 渲染
                        //     layer.render();
                        //     // 更新图例
                        //     function initLegend(colorLegend) {
                        //         var legends = colorLegend.map((item) => {
                        //             // color 为 gradient 传入的格式

                        //             console.log(`<li class="color-item" style="background-color: ${item.color}"></li>`, '88888');
                        //             return `<li class="color-item" style="background-color: ${item.color}"></li>`;
                        //         });

                        //         var ranges = colorLegend.map((item, index) => {
                        //             // range 可能为小数，可以自行取整计算
                        //             item.range[0] = Math.round(item.range[0]);
                        //             item.range[1] = Math.round(item.range[1]);

                        //             console.log(item.range, 'item.rangev=========');
                        //             // console.log(index,'index=========');
                        //             // console.log(colorLegend.length - 1,'colorLegend.length - 1=======');

                        //             if (index == colorLegend.length - 1) {
                        //                 console.log(
                        //                     `<li class="label-item">${item.range[0]}</li><li class="label-item">${item.range[1]}</li>`,
                        //                     'index == colorLegend.length - 1'
                        //                 );
                        //                 return `<li class="label-item">${item.range[0]}</li><li class="label-item">${item.range[1]}</li>`;
                        //             }

                        //             console.log(`<li class="label-item">${item.range[0]}</li>`, '99999999999');
                        //             return `<li class="label-item">${item.range[0]}</li>`;
                        //         });

                        //         console.log(legends.join(''), '66666666666');

                        //         document.getElementById('legend-color').innerHTML = legends.join('');
                        //         document.getElementById('legend-label').innerHTML = ranges.join('');
                        //     }
                        // }
                    });

                    // _this.showHeatMap(); // 获取普通热力图

                    // map.on('click', function (e) {
                    //     var myDiv = document.getElementById('hot-style');
                    //
                    //     if (myDiv.style.display === 'none') {
                    //         myDiv.style.display = 'block';
                    //     }
                    //     _this.arrlat = e.lnglat.Q;
                    //     _this.arrlng = e.lnglat.R;
                    //
                    //     let heatArray = [];
                    //     heatArray.push(_this.arrlng, _this.arrlat);
                    //     let heatNum = 0;
                    //     _this.countHot = 0;
                    //
                    //     for (let i = 0; i < _this.heatmapData.length; i++) {
                    //         let returnArray = [];
                    //         returnArray.push(_this.heatmapData[i].lng, _this.heatmapData[i].lat);
                    //
                    //         // 计算地图上两个位置的距离
                    //         var dis = AMap.GeometryUtil.distance(heatArray, returnArray);
                    //
                    //         if (dis < 500) {
                    //             // 如果距离小于500米，单量加和
                    //             heatNum += Number(_this.heatmapData[i].count);
                    //             _this.countHot = heatNum;
                    //         }
                    //     }
                    // });

                    // _this.hexagon(); // 获取蜂窝热力图
                // })
                // .catch((err) => {});
        },
        timeChange(val) {
            _this.search_data.start_stamp = val[0];
            _this.search_data.end_stamp = val[1];
            // console.log('选择时间');

            _this.getReLi();
        }
    }
};
</script>
<style>
.info span {
    min-width: 300px;
    max-width: 400px;
    color: #1b91ff;
}
.legend {
    position: absolute;
    bottom: 80px;
    right: 80px;
}

.legend ul {
    padding: 0;
    margin: 0;
    list-style: none;
}

.label-item {
    display: inline-block;
    width: 30px;
    margin-left: -2px;
    font-size: 14px;
}

html {
    font-size: 12px;
}
.amap-copyright {
    box-sizing: content-box;
}
* {
    box-sizing: border-box;
}
.input-textarea {
    color: grey;
    height: 8em;
    overflow: auto;
    border-radius: 0.4rem;
    border: 1px solid #ced4da;
    margin-bottom: 1rem;
}
body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji',
        'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
    line-height: 1.5;
    font-weight: 300;
    color: #111213;
}

hr {
    margin: 0.5rem 0;
    box-sizing: content-box;
    height: 0;
    overflow: visible;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
}

p {
    margin-top: 0;
    margin-bottom: 0;
}

label {
    display: inline-block;
    margin-bottom: 0.4rem;
}

label,
.btn {
    margin-left: 0;
    font-size: 1rem;
}

button,
input,
select {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    overflow: visible;
    text-transform: none;
}

[type='button']::-moz-focus-inner,
[type='reset']::-moz-focus-inner,
[type='submit']::-moz-focus-inner,
button::-moz-focus-inner {
    padding: 0;
    border-style: none;
}

input[type='checkbox'],
input[type='radio'] {
    box-sizing: border-box;
    padding: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0;
    margin: 0 0.5rem 0 0;
}

h4 {
    font-family: inherit;
    line-height: 1.8;
    font-weight: 300;
    color: inherit;
    font-size: 1.1rem;
    margin-top: 0;
    margin-bottom: 0.5rem;
}

.btn {
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid transparent;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    background-color: transparent;
    background-image: none;
    color: #25a5f7;
    border-color: #25a5f7;
    padding: 0.25rem 0.5rem;
    line-height: 1.5;
    border-radius: 1rem;
    -webkit-appearance: button;
    cursor: pointer;
}

.btn:hover {
    color: #fff;
    background-color: #25a5f7;
    border-color: #25a5f7;
}

.btn:hover {
    text-decoration: none;
}

.input-item {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-align: center;
    align-items: center;
    width: 100%;
    height: 3rem;
}

.input-item:last-child {
    margin-bottom: 0;
}

.input-item > select,
.input-item > input[type='text'],
.input-item > input[type='date'] {
    position: relative;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    width: 1%;
    margin-bottom: 0;
}

.input-item > select:not(:last-child),
.input-item > input[type='text']:not(:last-child),
.input-item > input[type='date']:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.input-item > select:not(:first-child),
.input-item > input[type='text']:not(:first-child),
.input-item > input[type='date']:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.input-item-prepend {
    margin-right: -1px;
}

.input-item-text,
input[type='text'],
input[type='date'],
select {
    height: calc(2.2rem + 2px);
}

.input-item-text {
    width: 6rem;
    text-align: justify;
    padding: 0.4rem 0.7rem;
    display: inline-block;
    text-justify: distribute-all-lines;
    /*ie6-8*/
    text-align-last: justify;
    /* ie9*/
    -moz-text-align-last: justify;
    /*ff*/
    -webkit-text-align-last: justify;
    /*chrome 20+*/
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    text-align: center;
    white-space: nowrap;
    background-color: #e9ecef;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}

.input-item-text input[type='checkbox'],
.input-item-text input[type='radio'] {
    margin-top: 0;
}

.input-card {
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border-radius: 0.25rem;
    width: 22rem;
    border-width: 0;
    border-radius: 0.4rem;
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 0.75rem 1.25rem;
}

.input-text {
    line-height: 2rem;
    margin-right: 2rem;
}

.info hr {
    margin-right: 0;
    margin-left: 0;
    border-top-color: grey;
}

.info {
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border-radius: 0.25rem;
    position: fixed;
    top: 1rem;
    background-color: white;
    width: auto;
    min-width: 22rem;
    border-width: 0;
    right: 1rem;
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
}

.code {
    left: 1.5rem;
    right: 1.5rem;
    top: 1.5rem;
    bottom: 1.5rem;
    overflow: auto;
    margin-bottom: 0rem;
}

.code .btn {
    top: 1rem;
    position: absolute;
    right: 1rem;
}

.code .result {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0.5rem;
    padding: 1rem;
    bottom: 1rem;
    position: absolute;
    top: 5.5rem;
    right: 1rem;
    left: 1rem;
    overflow: auto;
}

.code .status {
    color: #80adff;
    display: inline-block;
    font-size: 14px;
}

.code h4 {
    display: inline-block;
    max-width: 20rem;
    margin-right: 1rem;
    margin-bottom: 1rem;
}

select,
input[type='text'],
input[type='date'] {
    display: inline-block;
    width: 100%;
    padding: 0.375rem 1.75rem 0.375rem 0.75rem;
    line-height: 1.5;
    color: #495057;
    vertical-align: middle;
    background: #fff
        url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
        no-repeat right 0.75rem center;
    background-size: 8px 10px;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

input[type='text'],
input[type='date'] {
    background: #fff;
    padding: 0.375rem 0.75rem;
}

select:focus,
input[type='text']:focus,
input[type='date']:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.1rem rgba(128, 189, 255, 0.1);
}

.btn:focus {
    outline: 0;
    box-shadow: none;
}

select:focus::-ms-value,
input[type='text']:focus::-ms-value,
input[type='date']:focus::-ms-value {
    color: #495057;
    background-color: #fff;
}

/* native toastr */
.native-toast {
    position: fixed;
    background-color: rgba(50, 50, 50, 0.8);
    border-radius: 33px;
    color: white;
    left: 50%;
    text-align: center;
    padding: 6px 12px;
    opacity: 0;
    z-index: 99999;
    transition: transform 0.25s, opacity 0.25s, top 0.25s;
    box-sizing: border-box;
}

.native-toast-bottom {
    bottom: 50px;
    -ms-transform: translateX(-50%) translateY(50px);
    transform: translateX(-50%) translateY(50px);
}

.native-toast-bottom.native-toast-shown {
    opacity: 1;
    -ms-transform: translateX(-50%) translateY(0);
    transform: translateX(-50%) translateY(0);
}

.native-toast-bottom.native-toast-edge {
    bottom: 0;
}

.native-toast-top {
    top: 50px;
    -ms-transform: translateX(-50%) translateY(-50px);
    transform: translateX(-50%) translateY(-50px);
}

.native-toast-top.native-toast-shown {
    opacity: 1;
    -ms-transform: translateX(-50%) translateY(0);
    transform: translateX(-50%) translateY(0);
}

.native-toast-top.native-toast-edge {
    top: 0;
}

.native-toast-center {
    top: 0;
    -ms-transform: translateX(-50%) translateY(-50px);
    transform: translateX(-50%) translateY(-50px);
}

.native-toast-center.native-toast-shown {
    opacity: 1;
    top: 50%;
    -ms-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
}

.native-toast-edge {
    border-radius: 0;
    width: 100%;
    text-align: left;
}

@media screen and (min-width: 40rem) {
    .native-toast:not(.native-toast-edge) {
        max-width: 18rem;
    }
}

/*
  max-width does not seem to work in small screen?
*/

/*@media screen and (max-width: 768px) {
  .native-toast:not(.native-toast-edge) {
    max-width: 400px;
  }
}

@media screen and (max-width: 468px) {
  .native-toast:not(.native-toast-edge) {
    max-width: 300px;
  }
}*/

/* types */

.native-toast-error {
    background-color: #d92727;
    color: white;
}

.native-toast-success {
    background-color: #62a465;
    color: white;
}

.native-toast-warning {
    background-color: #fdaf17;
    color: white;
}

.native-toast-info {
    background-color: #5060ba;
    color: white;
}

[class^='native-toast-icon-'] {
    vertical-align: middle;
    margin-right: 8px;
}

[class^='native-toast-icon-'] svg {
    width: 16px;
    height: 16px;
}
.color-item {
    width: 30px;
    height: 20px;
    display: inline-block;
}
</style>
<style scoped>
/* 高德地图css */

.container {
    height: calc(100vh - 120px);
}
#container_details {
    height: calc(100vh - 200px);
    width: 100%;
    float: left;
    margin-top: 10px;
    position: relative;
}

.form-box {
    width: 35%;
    padding: 20px;
    box-sizing: border-box;
    float: left;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}
.input-card {
    position: absolute;
    right: 100px;
    bottom: 100px;
    width: 500px;
    height: 100px;
}
#hot-style {
    position: absolute;
    top: 200px;
    right: 100px;
    background-color: #fff;
    border-radius: 5px;
    width: 300px;
    padding: 10px;
}
</style>
